const tab_sections = {
    identity: 'Identitäten',
    integrations: 'Anbindungen',
    login_security: 'Anmeldung & Sicherheit',
    permissions: 'Berechtigungen',
    automation: 'Automatisierung',
    platform: 'Plattform',
    overview: 'Übersicht',
    authentication: 'Authentifizierung',
    authorization: 'Autorisierung',
    users: 'Benutzer',
    developer: 'Entwickler',
    tenant: 'Mieter',
};
export default Object.freeze(tab_sections);
